import logo from "../../../../public/projects/Saheel/images/logo/logo.png"
import codename from "../.././../../public/projects/Saheel/images/projects/codename.jpg"
// Saheel Properties
import overviewImage_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Overview/1.webp";
import bannerDesktopImage_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Banner/1.webp";
import bannerMobileImage_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Banner/2.webp";
import siteVisitBannerImage_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/SiteVisitBanner/1.webp";
import Location_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Location/L1.webp";
import Hightlights_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Highlights/1.webp";
import floorplan1_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/floorplan/1.webp";
import floorplan2_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/floorplan/2.webp";
import floorplan3_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/floorplan/3.webp";
// import floorplan4_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/floorplan/4.webp";
// import floorplan5_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/floorplan/5.webp";
import locationicon_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Overview/l.png";
import calicon_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Overview/c.png";
import newlaunchicon_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Overview/n.png";
// import loc from "./images/Overview/loc.png"
import gallery1_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Gallery/1.webp";
import gallery2_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Gallery/2.webp";
import gallery3_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Gallery/3.webp";
import gallery4_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Gallery/4.webp";
import gallery5_saheel_properties from "../../../../public/projects/Saheel/images/trendy_west/Gallery/5.webp";

// itrendhomes
import overviewImageitrendhomes from "../../../../public/projects/Saheel/itrendhomes/overview/1.webp";
import bannerDesktopImageitrendhomes from "../../../../public/projects/Saheel/itrendhomes/banner/1.webp";
import bannerMobileImageitrendhomes from "../../../../public/projects/Saheel/itrendhomes/banner/2.webp";
import Locationitrendhomes from "../../../../public/projects/Saheel/itrendhomes/location/1.webp";
import Hightlightsitrendhomes from "../../../../public/projects/Saheel/itrendhomes/highlights/1.webp";
import floorplan1itrendhomes from "../../../../public/projects/Saheel/itrendhomes/floorplan/1.webp";
import floorplan2itrendhomes from "../../../../public/projects/Saheel/itrendhomes/floorplan/2.webp";
import floorplan3itrendhomes from "../../../../public/projects/Saheel/itrendhomes/floorplan/3.webp";
import floorplan4itrendhomes from "../../../../public/projects/Saheel/itrendhomes/floorplan/4.webp";
import floorplan5itrendhomes from "../../../../public/projects/Saheel/itrendhomes/floorplan/5.webp";
import locationiconitrendhomes from "../../../../public/projects/Saheel/itrendhomes/overview/l.png";
import caliconitrendhomes from "../../../../public/projects/Saheel/itrendhomes/overview/c.png";
import newlaunchiconitrendhomes from "../../../../public/projects/Saheel/itrendhomes/overview/n.png";
import gallery1itrendhomes from "../../../../public/projects/Saheel/itrendhomes/gallery/1.webp";
import gallery2itrendhomes from "../../../../public/projects/Saheel/itrendhomes/gallery/2.webp";
import gallery3itrendhomes from "../../../../public/projects/Saheel/itrendhomes/gallery/3.webp";
import gallery4itrendhomes from "../../../../public/projects/Saheel/itrendhomes/gallery/4.webp";
import gallery5itrendhomes from "../../../../public/projects/Saheel/itrendhomes/gallery/5.webp";



// projectthree
import overviewImageprojectthree from "../../../../public/projects/Saheel/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/Saheel/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/Saheel/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/Saheel/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/Saheel/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/Saheel/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/Saheel/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/Saheel/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/Saheel/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/Saheel/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/Saheel/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/Saheel/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/Saheel/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/Saheel/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/Saheel/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/Saheel/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/Saheel/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/Saheel/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/Saheel/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/Saheel/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/Saheel/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/Saheel/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/Saheel/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/Saheel/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/Saheel/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/Saheel/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/Saheel/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/Saheel/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/Saheel/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/Saheel/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/Saheel/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/Saheel/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/Saheel/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/Saheel/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/Saheel/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/Saheel/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/Saheel/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/Saheel/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/Saheel/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/Saheel/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/Saheel/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/Saheel/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/Saheel/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/Saheel/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/Saheel/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/Saheel/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/Saheel/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/Saheel/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/Saheel/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/Saheel/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/Saheel/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/Saheel/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/Saheel/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/Saheel/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/Saheel/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/Saheel/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/Saheel/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/Saheel/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/Saheel/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/Saheel/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/Saheel/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/Saheel/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/Saheel/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/Saheel/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/Saheel/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/Saheel/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/Saheel/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/Saheel/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/Saheel/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/Saheel/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/Saheel/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/Saheel/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/Saheel/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/Saheel/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/Saheel/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/Saheel/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/Saheel/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/Saheel/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/Saheel/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/Saheel/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/Saheel/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/Saheel/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/Saheel/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/Saheel/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/Saheel/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/Saheel/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/Saheel/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/Saheel/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/Saheel/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/Saheel/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/Saheel/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/Saheel/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/Saheel/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/Saheel/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/Saheel/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/Saheel/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/Saheel/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/Saheel/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/Saheel/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/Saheel/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/Saheel/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/Saheel/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/Saheel/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/Saheel/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/Saheel/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/Saheel/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/Saheel/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/Saheel/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/Saheel/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/Saheel/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/Saheel/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/Saheel/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/Saheel/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/Saheel/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/Saheel/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/Saheel/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/Saheel/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/Saheel/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/Saheel/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/Saheel/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/Saheel/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/Saheel/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/Saheel/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/Saheel/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/Saheel/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/Saheel/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/Saheel/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/Saheel/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/Saheel/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/Saheel/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/Saheel/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/Saheel/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/Saheel/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/Saheel/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/Saheel/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/Saheel/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/Saheel/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/Saheel/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/Saheel/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/Saheel/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/Saheel/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/Saheel/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/Saheel/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/Saheel/projectten/gallery/5.webp";



export const developersSaheel = {
  properties: [
    {
      name: "Saheel Codename Trendy West ",
      image: codename,
      price: "On Request",
      location: "Baner",
      bed: "2 - 3 - 3.5 BHK",
      projectlocation: "Tathawade, Pune",
      state: "Pune",
      developer: "Saheel",
      size: "751 - 1041 sq.ft.",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },

  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "2008",
  },
  about: `Saheel Properties is committed to changing people's lives by designing environments that blend comfort, luxury, and innovation. We have established ourselves as a reputable brand in Pune's real estate industry thanks to our dedication to quality, customer-centric principles, and openness. Our projects are the ideal fusion of contemporary architecture and well-considered practicality, producing houses that are distinguished by their elegance and charm. `,
};

export const projectsaheel = {
  trendywest: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_saheel_properties,
      bannerMobileImage: bannerMobileImage_saheel_properties,
      textOverlay: "",
      data: {
        title: "Saheel Codename Trendy West",
        subtitle: "Baner, pune",
        starting_price: "On Request",
        payment_plan: "....",
        rerano: "P52100077008",
        status: "New Launch"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Saheel Codename Trendy West ",
      description: [
        "Saheel ITrend, a premium residential project by Saheel Properties, is set in Tathawade, Pune, offering 2, 2.5, and 3 BHK luxurious apartments. Designed for modern living, it ensures seamless connectivity to key city landmarks. The project features six elegant towers, each rising 14 floors, complemented by top-tier amenities like a swimming pool, gym, kids' play area, and more.",
        " Currently in its pre-launch phase, Saheel ITrend promises a perfect blend of comfort and urban sophistication. With contemporary architecture and thoughtfully designed spaces, it presents an ideal opportunity for those seeking a stylish and well-connected lifestyle in West Pune.",
      ],
      image: overviewImage_saheel_properties,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_saheel_properties,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_saheel_properties,
          title: "....",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_saheel_properties,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_saheel_properties,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
          area: "756 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2.5 BHK ",
          area: "901 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "1001 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "2 BHK ",
        area: "756 sq. ft.",
        price: "On Request*",
        image: floorplan1_saheel_properties,
      },
      {
        type: "2.5 BHK ",
        area: "901 sq. ft.",
        price: "On Request*",
        image: floorplan2_saheel_properties,
      },
      {
        type: "3 BHK ",
        area: "1001 sq. ft.",
        price: "On Request*",
        image: floorplan3_saheel_properties,
      },

    ],

    highlights: {
      images: Hightlights_saheel_properties,
      tagline: "Highlights",
      features: [
        "Clubhouse and Community Spaces.",
        "Fitness Center and Gym.",
        "Landscaped Gardens and Green Spaces.",
        "24/7 Security and Surveillance.",
        "Parking Facilities.",
      ],
    },

    location: {
      image: Location_saheel_properties,
      data: [
        {
          airport: {
            distance_time: "2 kms",
            name: "to IGI"
          },
          school: {
            distance_time: "3 Kms",
            name: "to DPS"
          },
          railwayormetro: {
            distance_time: "3 Kms",
            name: "to Gurugram"
          },
          hospital: {
            distance_time: "2 Kms",
            name: " to IGI"
          },
          mall: {
            distance_time: "1 Kms",
            name: "to Big Bazzar"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_saheel_properties },
        { image: gallery2_saheel_properties },
        { image: gallery3_saheel_properties },
        { image: gallery4_saheel_properties },
        { image: gallery5_saheel_properties },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel Codename Trendy , kindly share more details.",
    },

    faq: [

      {
        question: "Where is Saheel Codename Trendy West situated?",
        answer: `The project is situated in Tathawade, a rapidly developing suburb in Pune. This location offers excellent connectivity to major IT hubs, educational institutions, and healthcare facilities, making it a convenient choice for residents. `,
      },
      {
        question: "What types of apartments are available in this project?",
        answer: `Saheel Codename Trendy West offers 2 BHK, 2.5 BHK, and 3 BHK apartments. The sizes range from 751 sq. ft. to 1041 sq. ft., catering to various family sizes and preferences. `,
      },
      {
        question: "What amenities are provided in Saheel Codename Trendy West?",
        answer: `The project boasts a wide range of modern amenities, including a swimming pool, pleasure spa, yoga room, children's playground, parking facilities, 24/7 security with CCTV surveillance, community hall, clubhouse, gymnasium, landscaped park, and a party lawn.`,
      },
      {
        question: "Who is the developer behind Saheel Codename Trendy West?",
        answer: `The project is developed by Saheel Properties, a renowned real estate developer known for delivering high-quality residential projects in Pune.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `The RERA registration number for Saheel Codename Trendy West is yet to be announced.`,
      },
      {
        question: "What makes Saheel Codename Trendy West a standout choice for homebuyers?",
        answer: `Saheel Codename Trendy West in Tathawade, Pune, stands out as an exceptional choice for homebuyers seeking modern living combined with strategic location and premium amenities.`,
      },
      {
        question: "What is the starting price for apartments in this project?",
        answer: `The starting price for a 2 BHK apartment is approximately ₹82 lakhs, with 3 BHK apartments priced up to ₹1.18 crore. Prices may vary based on the specific unit and its features.`,
      },
      {
        question: "What are the nearby shopping centers and malls?",
        answer: `Residents can access various shopping centers and malls nearby, such as D-Mart (3.4 km away) and Phoenix Mall of the Millennium (3.7 km away), offering a range of retail and entertainment options.`,
      },
      {
        question: "Are there any public transportation facilities nearby?",
        answer: `Yes, the project offers excellent connectivity with public transportation. The Mumbai-Pune Expressway is easily accessible, and the Pimpri Railway Station is in close proximity, facilitating convenient travel.`,
      },
      {
        question: "What security measures are in place?",
        answer: `Saheel Codename Trendy West is equipped with 24/7 security services, including CCTV surveillance, to ensure a safe and secure living environment for all residents.`,
      },
    ],
    similar: {}
  },
  itrendhomes: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageitrendhomes,
      bannerMobileImage: bannerMobileImageitrendhomes,
      textOverlay: "",
      data: {
        title: "ITrend Homes",
        subtitle: " Hinjewadi Pune",
        starting_price: "₹ On Request ",
        payment_plan: "CLP",
        rerano: "--",
        status: "New Launch"
      }
    },

    overview: {
      heading: "ITrend Homes Hinjewadi Pune",
      description: [
        "Itrend Homes Hinjewadi Pune is a modern housing development of the Saheel Properties, offering 1.5, 2 and 3 BHK apartments for Urban lifestyle. The project is strategically located in Hinjewadi Phase II, and is ideal for professionals and families looking for modern places in Punes leading the hub.",
        "The project consists of six towers, each cultivating 15 floors, which includes a total of 555 units, which are spread over an extension of 6 acres. 2 BHK apartments in Pune Hinjewadi provide spacious and well -designed interiors from 772 to 871 square meters. These apartments are ready to enter, making them a practical option for immediate coating. ",
        "Residents of iTrend Homes have a swimming pool, gymnasium, clubhouse, children's sports area, landscape space and 24/7 Safety Hauger. The project also emphasizes smart home functions, which improves the experience that lives with modern technology.",
        "Hinjewadi's strategic location provides excellent connection for large IT parks, educational institutions, health facilities and entertainment fields. The upcoming Pune Metro Line 3 is prepared to further connect the city to the large parts of the city.For those looking for apartments in Hinjewadi Pune, Etrend Holmes offers a compelling alternative that combines a variety of modern designs, strategic places and features. Whether you are homebuir or an investor for the first time, these 2 BHK apartments in Pune Hinjewadi provide a balanced mix of comfort and convenience.",
      ],
      keywordLinks: {
      },
      image: overviewImageitrendhomes,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconitrendhomes,
          title: "₹ On Request     ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconitrendhomes,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconitrendhomes,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK ",
          area: "  On Request      ",
          price: "₹ On Request",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK  ",
          area: "   562 - 648 sq.ft. ",
          price: "₹ On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "1 BHK ",
        area: "  On Request      ",
        price: "₹ On Request",
        image: floorplan1itrendhomes,
      },
      {
        type: "2 BHK  ",
          area: "   562 - 648 sq.ft. ",
          price: "₹ On Request",
        image: floorplan2itrendhomes,
      }
    ],

    highlights: {
      images: Hightlightsitrendhomes,
      tagline: "Highlights",
      features: [
        "Located in Prime IT Hub of Hinjewadi Phase 2.",
        "Smartly Designed 1 & 2 BHK Premium Residences.",
        "Close to Leading IT Parks and Business Zones.",
        "Easy Access to Pune-Mumbai Expressway.",
        "Modern Clubhouse with Gym & Swimming Pool."
      ],
    },
    

    location: {
      image: Locationitrendhomes,
      data: [
        {
          airport: {
            distance_time: "28 Km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "1.1 Km",
            name: "Educon International School"
          },
          railwayormetro: {
            distance_time: "14.3 Km",
            name: "Pimpri Railway Station"
          },
          hospital: {
            distance_time: "5.4 Km",
            name: "Meduraa Multispeciality Hospital"
          },
          mall: {
            distance_time: "6.3 Km",
            name: "Radisson Blu Hotel"
          }
        }
      ]
    },
    

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1itrendhomes },
        { image: gallery2itrendhomes },
        { image: gallery3itrendhomes },
        { image: gallery4itrendhomes },
        { image: gallery5itrendhomes },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in ITrend Homes, kindly share more details.",
    },
    

    faq: [
      {
        question: "Where exactly is ITrend Homes located in Pune?",
        answer: "ITrend Homes is strategically located in Hinjewadi Phase 2, Pune."
      },
      {
        question: "What types of apartments are available in ITrend Homes?",
        answer: "The project offers 1, 2, and 3 BHK apartments."
      },
      {
        question: "Who is the developer of ITrend Homes?",
        answer: "ITrend Homes is developed by Saheel Properties and Kohinoor Group."
      },
      {
        question: "What amenities are available at ITrend Homes?",
        answer: "The project includes amenities like a clubhouse, swimming pool, gym, and landscaped gardens."
      },
      {
        question: "Is ITrend Homes RERA registered?",
        answer: "Yes, ITrend Homes is RERA registered."
      },
      {
        question: "How far is ITrend Homes from Rajiv Gandhi IT Park?",
        answer: "It is approximately 10–15 minutes away from Rajiv Gandhi IT Park."
      },
      {
        question: "Are there schools and hospitals nearby?",
        answer: "Yes, reputed schools, hospitals, and shopping malls are located within a 5–10 km radius."
      },
      {
        question: "Is there good public transport connectivity?",
        answer: "Yes, ITrend Homes is well-connected by buses, cabs, and upcoming metro routes."
      },
      {
        question: "Is it a good investment option?",
        answer: "Yes, ITrend Homes offers high rental yield and appreciation potential."
      },
      {
        question: "Can I avail home loan for buying a flat here?",
        answer: "Yes, home loans are available through leading banks and NBFCs for buying a home in ITrend Homes."
      }
    ],
    


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "Saheel The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Saheel The Trillion",
      description: [
        "Saheel The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Saheel Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Saheel Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Saheel Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Saheel The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Saheel": "/developers/Saheel",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Saheel The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Saheel The Trillion located?",
        answer: `Saheel The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Saheel The Trillion?",
        answer: `Saheel The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Saheel The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Saheel The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Saheel The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Saheel The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Saheel The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Saheel The Trillion?",
        answer: `Saheel The Trillion is developed by Saheel Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Saheel The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Saheel The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Saheel The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
}
